import React from 'react'

import Story from '../../components/Story/Story'
import { logServerSidePropsError } from '../../components/utilities/log-helper'
import regions from '../../config/regions'
import fetchQueryWrapper from '../../core/fetchQueryWrapper'
import removeCircular from '../../data/transformers/removeCircular'
import getStoryHref from '../../utils/getStoryHref'
import { RouteRedMetrics } from '../../utils/metrics'

import resolveResponse from 'contentful-resolve-response'

const StoryPreview = props => <Story {...props} />

const storyParams = slug => ({
  content_type: 'story',
  include: 3,
  'fields.slug[in]': slug
})

export async function getServerSideProps(context) {
  const redMetrics = new RouteRedMetrics({
    method: 'GET',
    route: 'contentful-preview/x'
  }).start()

  try {
    const { slug } = context?.params
    const regionName = context?.req?.headers?.host?.split('.')?.[0]
    const env = context?.query?.env

    const story = await fetchQueryWrapper(storyParams(slug), resolveResponse, true, env)

    if (!story?.length) {
      redMetrics.end({
        status: 404,
        error: 'Story not found'
      })

      return { notFound: true }
    }

    redMetrics.end({
      status: 200
    })

    return {
      props: {
        region: regions?.[regionName] || regions.default,
        path: getStoryHref({
          id: story?.[0]?.sys?.id,
          slug: story?.[0]?.fields?.slug,
          originalPublishedAt: story?.[0]?.fields?.originalPublishedAt
        }),
        data: removeCircular(story?.[0]?.fields)
      }
    }
  } catch (error) {
    logServerSidePropsError(error)

    redMetrics.end({
      status: 500,
      error: 'Failed to load page'
    })

    return { notFound: true }
  }
}

export default StoryPreview
